import { useContext, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';
import { Modal, Button, ThemeContext, useClickOutside } from '@forma/forma-ui-kit';

import styles from './lang-switch-dropdown.module.css';

export interface LangSwitchDropdownProps {
  current: string,
  items: { key: string, name: string }[],
  className?: string,
  onChange: (lang: string) => void
}

const LangSwitchDropdown = ({ current, items, className, onChange }: LangSwitchDropdownProps) => {
  const location = useLocation();
  const containerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const { viewport } = useContext(ThemeContext);

  useClickOutside(() => setIsOpen(false), containerRef);

  const handleClickLang = (lang: string) => {
    onChange(lang);
    setIsOpen(false);
  };

  if (viewport === 'phone') return (
    <div className={classNames(styles.root, className)} ref={containerRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={classNames(styles.dropdown, isOpen && styles.open)}
      >
        <ReactSVG src="/icons/globe.svg" className={styles.dropdownIcon} />
      </button>
      <Modal
        size="small"
        open={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <input type="hidden" autoFocus />
        <div className={styles.modalList}>
          {items.map(({ key, name }) => {
            const href = location.pathname === '/' ? location.pathname + key : location.pathname.replace('[locale]', key);
            return (
              <div className={styles.item} key={key}>
                <Button
                  as="a"
                  href={href}
                  onClick={() => handleClickLang(key)}
                  viewStyle="tertiary"
                  fullWidth
                // className={classNames(styles.link, current === lang && styles.active)}
                >
                  {name}
                </Button>
              </div>
            );
          })}
        </div>
      </Modal>
    </div>
  );

  return (
    <div className={classNames(styles.root, className)} ref={containerRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={classNames(styles.dropdown, isOpen && styles.open)}
      >
        <ReactSVG src="/icons/globe.svg" className={styles.dropdownIcon} />
        <span className={styles.dropdownText}>{items.find(({ key }) => current === key)?.name}</span>
        <ReactSVG src="/icons/dropdown.svg" className={styles.dropdownArrow} />
      </button>
      <div className={classNames(styles.list, isOpen && styles.open)}>
        {items.map(({ key, name }) => {
          const href = location.pathname === '/' ? location.pathname + key : location.pathname.replace('[locale]', key);
          return (
            <div className={styles.item} key={key}>
              <Button
                as="a"
                href={href}
                onClick={() => handleClickLang(key)}
                className={classNames(styles.link, current === key && styles.active)}
                viewStyle="secondary"
                size="small"
              >
                {name}
              </Button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LangSwitchDropdown;
